import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { ADD_CONFIGS, UPDATE_ROUTER_CONFIG } from "../../appConstants.js";
import axiosInstance from "../AxiosInstance/AxiosInstance";
import "../HomeHeader.css";
import "../Modal/Modal.css";
import {
  fetchAnonProtocols,
  fetchFilters,
  fetchPacsConfiguration,
  fetchPlatformConfigs,
} from "./Utility";

const ConfigureModal = (props) => {
  const { editData } = props;

  const [anonPro, setAnonPro] = useState();
  const [filter, setfilter] = useState("");
  const [pacsconfig, setpacsconfig] = useState();
  const [platform, setplatform] = useState();
  const [name, setname] = useState("");
  const [time, setTime] = useState(10);
  const [pushBackResults, setPushBackResults] = useState();
  const [anonData, setAnonData] = useState();
  const [filterData, setFilterData] = useState();
  const [pacsData, setPacsData] = useState();
  const [platformData, setPlatformData] = useState();
  const [error, seterror] = useState(false);
  const [id, setId] = useState("");

  const modalStyles = {
    color: "white",
    fontWeight: "bold",
    position: "absolute",
    top: 0,
    right: 0,
    width: "30%",
    padding: "2rem",
    height: "100vh",
    backdropFilter: "blur(14.5px)",
    background: "transparent",
    boxShadow: " 0 0 6px 0 rgba(149,149,149,0.5)",
  };

  useEffect(() => {
    if (Object.keys(editData).length) {
      setId(editData.id);
      setname(editData.config_name);
      setTime(editData.time_interval);
      setpacsconfig({
        id: editData.pacs_config_data.id,
        value: editData.pacs_config_data.name,
        label: editData.pacs_config_data.name,
      });
      if (editData.filter_data == null) {
        setfilter({
          id: "",
          value: "",
          label: "None",
        });
      } else {
        setfilter({
          id: editData.filter_data.id,
          value: editData.filter_data.name,
          label: editData.filter_data.name,
        });
      }

      setplatform({
        id: editData.platform_data.id,
        value: editData.platform_data.name,
        label: editData.platform_data.name,
      });
      setAnonPro({
        id: editData.anon_protocol_data.id,
        value: editData.anon_protocol_data.name,
        label: editData.anon_protocol_data.name,
      });
      setPushBackResults({
        // id: editData.push_back_results?,
        value: editData.push_back_results,
        label:
          editData.push_back_results === 1
            ? "Automatic"
            : editData.push_back_results === 2
            ? "Manual"
            : editData.push_back_results === 3
            ? "Snapshot"
            : "Do Not Push",
      });
    }
  }, [editData]);

  const anonchange = (e) => {
    setAnonPro(e);
  };
  const filterschange = (e) => {
    setfilter(e);
  };
  const pacsconfigchange = (e) => {
    setpacsconfig(e);
  };
  const platformchange = (e) => {
    setplatform(e);
  };
  const pushBackchange = (e) => {
    setPushBackResults(e);
  };
  const namechange = (e) => {
    setname(e.target.value);
  };

  const submithandler = () => {
    if (
      !name ||
      !time ||
      !pacsconfig ||
      !filter ||
      !platform ||
      !anonPro ||
      !pushBackResults
    ) {
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }

    const fetchData = async () => {
      var filterobj = {};
      if (filter.id === "") {
        filterobj = {
          config_name: name,
          time_interval: time,
          pacs_config: pacsconfig.id,
          platform: platform.id,
          anon_protocol: anonPro.id,
          push_back_results: pushBackResults.value,
        };
      } else
        filterobj = {
          config_name: name,
          time_interval: time,
          pacs_config: pacsconfig.id,
          filter: filter.id,
          platform: platform.id,
          anon_protocol: anonPro.id,
          push_back_results: pushBackResults.value,
        };
      try {
        const response = await axiosInstance.post(`${ADD_CONFIGS}`, filterobj, {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        });
        setname("");
        setTime("");
        setAnonPro();
        setfilter();
        setpacsconfig();
        setplatform();
        setPushBackResults();
        if (response.data.success) {
          toast.success(`${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          props.setUpdate((state) => !state);
          setTimeout(() => {
            props.handleClose();
          }, 1000);
        } else {
          toast.error(`Error: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
    fetchData();
  };

  const submitEdithandler = () => {
    if (
      !name ||
      !time ||
      !pacsconfig ||
      !filter ||
      !platform ||
      !anonPro ||
      !pushBackResults
    ) {
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }

    const fetchData = async () => {
      var filterobj = {};
      if (filter.id === "") {
        filterobj = {
          id: id,
          config_name: name,
          time_interval: time,
          pacs_config: pacsconfig.id,
          platform: platform.id,
          anon_protocol: anonPro.id,
          push_back_results: pushBackResults.value,
        };
      } else
        filterobj = {
          id: id,
          config_name: name,
          time_interval: time,
          pacs_config: pacsconfig.id,
          filter: filter.id,
          platform: platform.id,
          anon_protocol: anonPro.id,
          push_back_results: pushBackResults.value,
        };

      try {
        const response = await axiosInstance.put(
          `${UPDATE_ROUTER_CONFIG}`,
          filterobj,
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        if (response.data.success) {
          toast.success(`${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          props.setUpdate((state) => !state);
          setTimeout(() => {
            props.handleClose();
          }, 1000);
        } else {
          toast.error(`Error: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
    fetchData();
  };

  useEffect(() => {
    const result = async () => {
      // Anon Protocols
      const anonResponse = await fetchAnonProtocols();
      setAnonData(anonResponse?.data?.items);

      // Filters
      const filterResponse = await fetchFilters();
      setFilterData(filterResponse?.data?.items);

      // Pacs Configuration
      const pacsResponse = await fetchPacsConfiguration();
      setPacsData(pacsResponse?.data?.items);

      // Platform Configs
      const platformResponse = await fetchPlatformConfigs();
      setPlatformData(platformResponse?.data?.items);
    };

    result();
  }, []);

  const AnonOptions = anonData?.map((item) => ({
    id: item.id,
    value: item.name,
    label: item.name,
  }));

  let filtersOptions = [];

  if (filterData) {
    filtersOptions = [
      {
        id: "",
        value: "",
        label: "None",
      },
      ...filterData.map((item) => ({
        id: item.id,
        value: item.name,
        label: item.name,
      })),
    ];
  }

  const pacsConfigsOptions = pacsData?.map((item) => ({
    id: item.pacs_config_id,
    value: item.pacs_config_name,
    label: item.pacs_config_name,
  }));

  const PlatfromOptions = platformData?.map((item) => ({
    id: item.id,
    value: item.name,
    label: item.name,
  }));

  const PushBackOptions = [
    {
      id: 1,

      label: "Automatic",
      value: 1,
    },
    {
      id: 2,
      label: "Manual",
      value: 2,
    },
    {
      id: 3,
      label: "Snapshot",
      value: 3,
    },
    {
      id: 4,
      label: "Do Not Push",
      value: 0,
    },
  ];

  return (
    <div>
      <Modal
        className="Backdrop"
        onClose={props.handleClose}
        open={props.ModalState}
        sx={{ width: "300", background: "transparent" }}
      >
        <Box sx={modalStyles}>
          <div className="d-flex justify-content-between align-items-center">
            <div className="h5 font-weight-bold  mt-2">Add Configuration</div>
            <IconButton
              className="text-light mb-3"
              onClick={props.handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="mt-3 rounded">
            <div className="sort_search_header_field">Rule Name*</div>

            <div className="mt-1">
              <input
                className="text-input-modal"
                onChange={namechange}
                required
                id="rule"
                value={name}
              />
              {!name && error && (
                <span className="errorStyles">RULE Required</span>
              )}
            </div>

            <div className="mt-3">
              <div className="sort_search_header_field">Anon Protocol*</div>
              <Select
                placeholder="Select Anon Protocol"
                name="ANON_PROTOCOL"
                options={AnonOptions}
                onChange={anonchange}
                value={anonPro}
                isClearable={true}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: "5px",
                  colors: {
                    ...theme.colors,
                    primary75: "white",
                    primary50: "white",
                    primary25: "white",
                    danger: "#DE350B",
                    dangerLight: "#FFBDAD",
                    neutral0: "black",
                    neutral5: "hsl(0, 0%, 95%)",
                    neutral10: "hsl(0, 0%, 90%)",
                    neutral20: "hsl(0, 0%, 80%)",
                    neutral30: "hsl(0, 0%, 70%)",
                    neutral40: "hsl(0, 0%, 60%)",
                    neutral50: "hsl(0, 0%, 50%)",
                    neutral60: "hsl(0, 0%, 40%)",
                    neutral70: "hsl(0, 0%, 30%)",
                    neutral80: "white",
                    neutral90: "hsl(0, 0%, 10%)",
                  },
                })}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    width: "100%",
                    backgroundColor: "black", // Set the background color to black
                    color: "white",
                    zIndex: 9999,
                    border: "1px solid #0f9077",
                    boxShadow: "0 0 1px rgba(0, 0, 0, 0)",
                    "&:hover": {
                      border: "1px solid #0f9077",
                    },
                  }),

                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: "black", // Set the background color to black
                    color: "white",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    fontWeight: "normal", // Make the placeholder text normal
                  }),
                }}
              />
              {!anonPro && error && (
                <span className="errorStyles">ANON PROTOCOL Required</span>
              )}
            </div>

            <div className="mt-3">
              <div className="sort_search_header_field">Filter*</div>
              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: "5px",
                  colors: {
                    ...theme.colors,
                    primary75: "white",
                    primary50: "white",
                    primary25: "white",
                    danger: "#DE350B",
                    dangerLight: "#FFBDAD",
                    neutral0: "black",
                    neutral5: "hsl(0, 0%, 95%)",
                    neutral10: "hsl(0, 0%, 90%)",
                    neutral30: "hsl(0, 0%, 70%)",
                    neutral40: "hsl(0, 0%, 60%)",
                    neutral50: "hsl(0, 0%, 50%)",
                    neutral60: "hsl(0, 0%, 40%)",
                    neutral70: "hsl(0, 0%, 30%)",
                    neutral80: "white",
                    neutral90: "hsl(0, 0%, 10%)",
                  },
                })}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    width: "100%",
                    backgroundColor: "black",
                    color: "white",
                    border: "1px solid #0f9077",
                    boxShadow: "0 0 1px rgba(0, 0, 0, 0)",
                    "&:hover": {
                      border: "1px solid #0f9077",
                    },
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: "black",
                    color: "white",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  clearIndicator: (provided) => ({
                    ...provided,
                    cursor: "pointer",
                  }),
                }}
                isClearable={true}
                placeholder="Select Filter"
                name="FILTER"
                options={filtersOptions}
                onChange={filterschange}
                value={filter}
              />

              {!filter && error && (
                <span className="errorStyles">FILTER Required</span>
              )}
            </div>

            <div className="mt-3">
              <div className="sort_search_header_field">PACS Config*</div>
              <Select
                placeholder="Select PACS Config"
                name="PACS_CONFIG"
                options={pacsConfigsOptions}
                onChange={pacsconfigchange}
                isClearable={true}
                value={pacsconfig}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: "5px",
                  colors: {
                    ...theme.colors,
                    primary75: "white",
                    primary50: "white",
                    primary25: "white",
                    danger: "#DE350B",
                    dangerLight: "#FFBDAD",
                    neutral0: "black",
                    neutral5: "hsl(0, 0%, 95%)",
                    neutral10: "hsl(0, 0%, 90%)",
                    neutral20: "hsl(0, 0%, 80%)",
                    neutral30: "hsl(0, 0%, 70%)",
                    neutral40: "hsl(0, 0%, 60%)",
                    neutral50: "hsl(0, 0%, 50%)",
                    neutral60: "hsl(0, 0%, 40%)",
                    neutral70: "hsl(0, 0%, 30%)",
                    neutral80: "white",
                    neutral90: "hsl(0, 0%, 10%)",
                  },
                })}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    width: "100%",
                    backgroundColor: "black",
                    color: "white",
                    border: "1px solid #0f9077",
                    boxShadow: "0 0 1px rgba(0, 0, 0, 0)",
                    "&:hover": {
                      border: "1px solid #0f9077",
                    },
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: "black",
                    color: "white",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  clearIndicator: (provided) => ({
                    ...provided,
                    cursor: "pointer",
                  }),
                }}
              />
              {!pacsconfig && error && (
                <span className="errorStyles">CONFIG Required</span>
              )}
            </div>

            <div className="mt-3">
              <div className="sort_search_header_field">Platform*</div>
              <Select
                placeholder="Select Platform"
                name="PLATFORM"
                options={PlatfromOptions}
                onChange={platformchange}
                isClearable={true}
                value={platform}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: "5px",
                  colors: {
                    ...theme.colors,
                    primary75: "white",
                    primary50: "white",
                    primary25: "white",
                    danger: "#DE350B",
                    dangerLight: "#FFBDAD",
                    neutral0: "grey",
                    neutral5: "hsl(0, 0%, 95%)",
                    neutral10: "hsl(0, 0%, 90%)",
                    neutral20: "hsl(0, 0%, 80%)",
                    neutral30: "hsl(0, 0%, 70%)",
                    neutral40: "hsl(0, 0%, 60%)",
                    neutral50: "hsl(0, 0%, 50%)",
                    neutral60: "hsl(0, 0%, 40%)",
                    neutral70: "hsl(0, 0%, 30%)",
                    neutral80: "white",
                    neutral90: "hsl(0, 0%, 10%)",
                  },
                })}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    width: "100%",
                    backgroundColor: "black",
                    color: "white",
                    border: "1px solid #0f9077",
                    boxShadow: "none",
                    "&:hover": {
                      border: "1px solid #0f9077",
                    },
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: "black",
                    color: "white",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  clearIndicator: (provided) => ({
                    ...provided,
                    cursor: "pointer",
                  }),
                }}
              />
              {!platform && error && (
                <span className="errorStyles">PLATFORM Required</span>
              )}
            </div>

            <div className="mt-3">
              <div className="sort_search_header_field">Push Back Results</div>
              <Select
                placeholder="Push Back Results"
                name="pushBack"
                options={PushBackOptions}
                onChange={pushBackchange}
                isClearable={true}
                value={pushBackResults}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: "5px",
                  colors: {
                    ...theme.colors,
                    primary75: "white",
                    primary50: "white",
                    primary25: "white",
                    danger: "#DE350B",
                    dangerLight: "#FFBDAD",
                    neutral0: "grey",
                    neutral5: "hsl(0, 0%, 95%)",
                    neutral10: "hsl(0, 0%, 90%)",
                    neutral20: "hsl(0, 0%, 80%)",
                    neutral30: "hsl(0, 0%, 70%)",
                    neutral40: "hsl(0, 0%, 60%)",
                    neutral50: "hsl(0, 0%, 50%)",
                    neutral60: "hsl(0, 0%, 40%)",
                    neutral70: "hsl(0, 0%, 30%)",
                    neutral80: "white",
                    neutral90: "hsl(0, 0%, 10%)",
                  },
                })}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    width: "100%",
                    backgroundColor: "black",
                    color: "white",
                    border: "1px solid #0f9077",
                    boxShadow: "none",
                    "&:hover": {
                      border: "1px solid #0f9077",
                    },
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: "black",
                    color: "white",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  clearIndicator: (provided) => ({
                    ...provided,
                    cursor: "pointer",
                  }),
                }}
              />
              {!pushBackResults && error && (
                <span className="errorStyles">PUSHBACK Required</span>
              )}
            </div>

            {/* <div className="mt-3">
              <div className="sort_search_header_field">Time Interval</div>
              <input
                onChange={(e) => {
                  setTime(e.target.value);
                }}
                required
                className="text-input-modal"
                id="outlined-required"
                value={time}
                placeholder="Time Interval"
              />
              {!time && error && (
                <span className="errorStyles">TIME Required</span>
              )}
            </div> */}

            <div className="btn-filter mt-3 text-center">
              <button
                className="btn-class"
                onClick={
                  Object.keys(editData).length
                    ? submitEdithandler
                    : submithandler
                }
              >
                SUBMIT
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};
export default ConfigureModal;
